import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { AddCircle } from "../../assets/AddCircle";
import { Logout } from "../../assets/Menu/Logout";
import { MenuArrow } from "../../assets/Menu/MenuArrow";
import { MenuArrowSmall } from "../../assets/Menu/MenuArrowSmall";
import { MenuArrowSquare } from "../../assets/Menu/MenuArrowSquare";
import { PodDash } from "../../assets/Podcast/PodDash";
import { PodEpisodes } from "../../assets/Podcast/PodEpisodes";
import { UserPassword } from "../../assets/User/UserPassword";
import { UserProfile } from "../../assets/User/UserProfile";
import { UserWallet } from "../../assets/User/UserWallet";
import { formatPrice } from "../helper/Price";
import logo from "../../assets/Farazandishan-logo-1.png";
import { MenuClose } from "../../assets/Menu/MenuClose";
import  HamMenu  from "../../assets/Menu/HamMenu.svg"

const StyleCss = styled.div`
  position: relative;
  margin: 0;
  .navbar {
    height: 60px;
    width: calc(90vw - calc(100px + 2rem));
    position: fixed;
    top: 0;
    right: 0;
    padding: 0 10vw 0 calc(100px + 2rem);
    display: flex;
    z-index: 200;
    background-color: #fff;
    box-shadow: 0px 2px 8px #00000010;
    transition: all 0.3s ease-in-out;
    &.open {
        padding: 0 10vw 0 calc(220px + 2rem);
        width: calc(90vw - calc(220px + 2rem));
    }
    .image {
        padding: 0.5rem 0;
        img {
            height: 100%;
        }
    }
    .expand {
        flex-grow: 1;
    }
    .nav-item {
        margin: 7.5px;
        padding: 5px 10px;
        border: 1px solid var(--n-grey-3);
        border-radius: 8px;
        display: flex;
        align-items: center;
    }
    .wallet {
        cursor: pointer;
        position: relative;
        margin-left: 0;
        text-decoration: none;
        .name {
            margin: 0 0.3rem;
            color: var(--n-grey-7)
        }
        .icon {
            svg {
                display: block;
                fill: var(--n-grey-7);
                width: 24px;
                height: 24px;
            }
        }
        .arrow {
            svg {
                transform: rotate(-90deg);
                display: block;
                stroke: var(--n-grey-7);
                width: 16px;
                height: 16px;
            }
        }
        :hover{
            border: 1px solid var(--n-grey-7);
            .name {
                color: var(--n-grey-9)
            }
            .icon {
                svg {
                    fill: var(--n-grey-9);
                }
            }
            
        }
    }
    .profile {
        cursor: pointer;
        position: relative;
        margin-left: 0;
        .name {
            margin: 0 0.3rem;
            color: var(--n-grey-7)
        }
        .icon {
            svg {
                display: block;
                fill: var(--n-grey-7);
                width: 24px;
                height: 24px;
            }
        }
        .arrow {
            svg {
                transform: rotate(-90deg);
                display: block;
                stroke: var(--n-grey-7);
                width: 16px;
                height: 16px;
            }
        }
        .bridge {
            display: none;
            position: absolute;
            top: 40px;
            right: 0;
            left: 0;
            height: 20px;
        }
        .profile-list {
            display: none;
            flex-direction: column;
            position: absolute;
            top: 60px;
            right: 0;
            left: 0;
            background-color: #fff;
            border: 1px solid var(--n-grey-3);
            border-radius: 8px;
            .devider {
                width: 100%;
                height: 1px;
                border-bottom: 1px solid var(--n-grey-3);
            }
            .profile-items {
                margin: 0.5rem;
                display: flex;
                text-decoration: none;
                color: var(--n-grey-7);
                align-items: center;
                :hover{
                    color: var(--n-grey-9);
                    .icon {
                        svg {
                            fill: var(--n-grey-9);
                        }
                    }
                    .arrow {
                        svg {
                            stroke: var(--n-grey-9);
                        }
                    }
                }
                .icon {
                    width: 16px;
                    svg {
                        display: block;
                        width: 100%;
                        fill: var(--n-grey-7);
                    }
                    img {
                        width: 100%;
                        display: block;
                        border-radius: 100px;
                    }
                }
                .title {
                    flex-grow: 1;
                    font-size: 11px;
                    margin: 0 0.3rem;
                }
                .arrow {
                    width: 12px;
                    svg {
                        transform: none;
                        width: 100%;
                        stroke: var(--n-grey-7);
                    }
                }
            }
        }
        :hover{
            border: 1px solid var(--n-grey-7);
            .name {
                color: var(--n-grey-9)
            }
            .icon {
                svg {
                    fill: var(--n-grey-9);
                }
            }
            .arrow {
                svg {
                    stroke: var(--n-grey-9);
                }
            }
            .bridge {
                display: flex;
            }
            .profile-list {
                display: flex;
            }
        }
    }
  }
  .menu {
    z-index: 500;
    width: 100px;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
    box-shadow: 0px 10px 60px #E2ECF980;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    &.open {
        width: 220px;
        .image {
            margin: 25px auto 0;
            width: 77px;
            height: 77px;
        }
        .main-icon {
            padding: 18px 18px;
            svg {
                transform: rotate(0deg);
            }
        }
        .nav-item {
            flex-direction: row;
            .text {
                font-size: 14px;
            }
        }
    }
    .main-icon {
        padding: 18px 38px;
        display: flex;
        justify-content: flex-end;
        transition: all 0.3s ease-in-out;
        svg {
            transform: rotate(180deg);
            transition: all 0.3s ease-in-out;
            stroke: var(--n-grey-8);
        }
    }
    svg {
        width: 24px;
        height: 24px;
    }
    .image {
        margin: 47px auto 0;
        width: 55px;
        height: 55px;
        border-radius: 50%;
        background-color: var(--n-grey-3);
        overflow: hidden;
        transition: all 0.3s ease-in-out;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            width: 100%;
            height: 100%;
        }
        svg {
            width: 50%;
            height: 50%;
            display: block;
            fill: var(--n-grey-5)
        }
    }
    .devider {
        margin: 1rem 0;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid var(--n-grey-3);
    }
    .nav-item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 0.6rem 1rem;
        margin: 0.8rem 1rem;
        border-radius: 8px;
        text-decoration: none;
        .text {
            margin: 0 0.5rem 0 0.4rem;
            white-space: nowrap;
            font-size: 10px;
            color: var(--n-grey-8);
        }
        .icon {
            svg {
                display: block;
                fill: var(--n-grey-8)
            }
            .stroke {
                fill: none;
                stroke: var(--n-grey-8)
            }
        }
        .arrow {
            svg {
                display: block;
                stroke: var(--n-grey-8);
                width: 16px;
                height: 16px;
            }
        }
        &.active {
            background-color: var(--n-primary-1-o);
            .text {
                color: var(--n-primary-1)
            }
            .icon {
                svg {
                    fill: var(--n-primary-1)
                }
                .stroke {
                    fill: none;
                    stroke: var(--n-primary-1)
                }
            }
            .arrow {
                svg {
                    stroke: var(--n-primary-1);
                }
            }
        }
    }
  }
  .selector {
    text-align: center;
    margin: 1rem 0 0.5rem;
    font-size: 12px;
    font-weight: 400;
    transition: all 0.3s ease-in-out;
    display: flex;
    justify-content: center;
    color: var(--n-grey-9);
    .pod-title {
        cursor: pointer;
        flex-grow: 1;
        display: flex;
        justify-content: center;
    }
    
    .icon {
        margin: 0 0.3rem;
        display: none;
        align-items: center;
        justify-content: center;
        svg {
            width: 16px;
            height: 16px;
            display: block;
            stroke: var(--n-grey-9);
        }
    }
    .bg-click {
        display: none;
        position: fixed;
        background-color: transparent;
        inset: 0 0 0 0;
        &.active {
            display: block;
        }
    }
    .podcast-selector {
        display: none;
        position: fixed;
        top: 150px;
        right: 110px;
        background-color: var(--n-body-2);
        flex-direction: column;
        width: 250px;
        border-radius: 8px;
        overflow: hidden;
        transition: all 0.3s ease-in-out;
        box-shadow: 0px 1px 4px 0px #00000014;

        .devider-s{
            margin: 0.3rem 0;
            width: 100%;
            height: 1px;
            border-bottom: 1px solid var(--n-grey-3);
        }
        .podcast-item {
            cursor: pointer;
            margin: 0;
            padding: 0.4rem 0.5rem;
            display: flex;
            font-size: 12px;
            align-items: center;
            text-decoration: none;
            color: var(--n-grey-6);
            
            &.active {
                background-color: var(--n-primary-1-o);
                .title {
                    color: var(--n-primary-1);
                }
            }
            .svg {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                svg {
                    fill: var(--n-grey-7);
                }
            }
            .image {
                width: 24px;
                height: 24px;
                margin: 0;
                border-radius: 4px;
            }
            .title {
                margin: 0 0.3rem;
                color: var(--n-grey-6);
            }
        }
        
        &.active {
            display: flex;
        }
    }
    &.open {
        font-size: 16px;
        font-weight: normal;
        .podcast-selector {
            right: 230px;
        }
        .icon {
            display: flex;
        }
    }
  }
  .contents {
    margin: 60px 10vw 0 100px;
    padding: 2rem 0 2rem 2rem;
    transition: all 0.3s ease-in-out;
    &.open {
        margin: 60px 10vw 0 220px;
    }
  }
  @media screen and (max-width: 800px ){
    .menu{
        &.open{
            display: none;
        }
        .main-icon{
            padding: 5px;
            width: 1rem;
            margin:5px;
            float: left;
            svg{
                stroke: none;
            }
        }
        .image{
            margin: 3rem auto 0;
        }
    }
    .navbar {
        padding: 0 1rem;
        width: calc(100% - 2rem);
        justify-content: space-between;
        .wallet , .notif , .expand{
            display: none;
        }
        &.open{
            padding: 0 1rem;
            width: calc(100% - 2rem);
        }
        .nav-item{
            margin: 7.5px 0;
        }
        .ham-btn{
            display: flex;
        }
        .profile{
            background-color: var(--n-grey-1);
            .name , .arrow{
                display: none;
            }
            .profile-list{
                top: 45px;
                right: -5.2rem;
                .notif{
                    padding: 5px;
                    border-radius: 4px;
                    svg{
                        width: 16px;
                        height: 16px;
                    }
                }
            }
        }
    }
    .contents{
        margin: 2.5rem 0 ;
        padding: 2rem 1rem ;
        width: calc(100% - 2rem);
        &.open{
            margin: 2.5rem 0;
            padding: 2rem 1rem ;
            width: calc(100% - 2rem); 
        }
        .dark-mode{
            display: flex;
        }
    }
  }
`;

let profileData = [
    {
        icon: <UserProfile/>,
        title: 'Personal Info',
        link: 'personal-data'
    },
    {
        icon: <PodEpisodes/>,
        title: 'Resume',
        link: 'resume'
    },
    // {
    //     icon: <UserPassword/>,
    //     title: 'تغییر رمز عبور',
    //     link: 'change-password'
    // },
    // {
    //     icon: <UserEmail/>,
    //     title: 'تغییر ایمیل',
    //     link: 'change-email'
    // },
    // {
    //     icon: <UserMobile/>,
    //     title: 'تغییر شماره همراه',
    //     link: 'change-mobile'
    // },
]



function MainLayoutV3(props) {
    const [opened , setOpen] = useState(true);
    const [openSelector , setOpenSelector] = useState(false);
    const history = useLocation();

    const makeProfile = () => {
        let items = []
        items = profileData.map((value, index) => {
            return (
                <Link className="profile-items" to={'/work/' + value.link} key={index}>
                    <div className="icon">
                        {value.icon}
                    </div>
                    <div className="title">
                        {value.title}
                    </div>
                    <div className="arrow" style={{transform: "rotate(180deg)"}}>
                        <MenuArrowSmall/>
                    </div>
                </Link>
            )
        })
        return (
            <div className="profile-list">
                {items}
                <div className="devider"/>
                <Link className="profile-items" to={'/logout'}>
                    <div className="icon">
                        <Logout style={{color: '#ED303D'}}/>
                    </div>
                    <div className="title" style={{color: '#ED303D'}}>
                        Logout
                    </div>
                </Link>
            </div>
        )
    }
    const makePodcastDrop = () => {
        return (
            <div className="profile-list">
                <Link className="profile-items" to={'/work/payroll'}>
                    <div className="icon">
                        <PodEpisodes/>
                    </div>
                    <div className="title">
                        Payroll
                    </div>
                    <div className="arrow" style={{transform: "rotate(180deg)"}}>
                        <MenuArrowSmall/>
                    </div>
                </Link>
                <div className="devider"/>
                <Link className="profile-items" to={'/work'}>
                    <div className="icon">
                        <PodDash/>
                    </div>
                    <div className="title">
                        Dashboard
                    </div>
                    <div className="arrow" style={{transform: "rotate(180deg)"}}>
                        <MenuArrowSmall/>
                    </div>
                </Link>
            </div>
        )
    }

    const makeMenus = () => {
        return props.menu.map((value , index) => {
            let link = props.base + '/' + value.link;
            let tempLink = link.split('/').length;
            let path = history.pathname;
            let tempPath = path.split('/').slice(0, tempLink).join('/');
            return (
                <Link to={link} className={"nav-item " + ((tempPath === link) ? 'active' : '')} key={index} onClick={() => setOpen(false)}>
                    <div className="icon">
                        {value.icon}
                    </div>
                    <div className="text">
                        {value.title}
                    </div>
                    {(!opened) ? (
                        ''
                    ) : (
                        <div className="arrow">
                            <MenuArrowSmall/>
                        </div>
                    )}
                    
                </Link>
            )
        })
    }

    const makeSelector = () => {
        if(props.type === 'podcast'){
            let podcasts = props.selector.map((value, index) => {
                if(value.podID === props.podID){
                    return (
                        <div
                            className={"podcast-item active"} 
                            key={index}
                        >
                            <div className="image">
                                <img src={value.image} alt={value.title}/>
                            </div>
                            <div className="title">
                                {value.title}
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <Link
                            to={'/podcast/' + value.podID}
                            className={"podcast-item"} 
                            key={index}
                        >
                            <div className="image">
                                <img src={value.image} alt={value.title}/>
                            </div>
                            <div className="title">
                                {value.title}
                            </div>
                        </Link>
                    )
                }
                
            })
            return (
                <React.Fragment>
                    <div className="pod-title" onClick={() => setOpenSelector(!openSelector)}>
                        <div className="title">
                            {props.name}
                        </div>
                        <div className="icon">
                            <MenuArrowSquare/>
                        </div>
                    </div>
                    <div 
                        className={"bg-click " + ((openSelector) ? 'active' : '')} 
                        onClick={() => setOpenSelector(false)}
                    />
                    <div className={"podcast-selector " + ((openSelector) ? 'active' : '')}>
                        {podcasts}
                        <Link to={'/addnewpodcast'} className="podcast-item">
                            <div className="svg">
                                <AddCircle/>
                            </div>
                            <div className="title">
                                افزودن پادکست
                            </div>
                        </Link>
                        <div className="devider-s"/>
                        <Link to={'/'} className="podcast-item">
                            <div className="svg">
                                <PodDash/>
                            </div>
                            <div className="title">
                                مدیریت پادکست‌ها
                            </div>
                        </Link>
                    </div>
                </React.Fragment>
            )
        } else {
            return props.name;
        }
    }


    const navLastItem = () => {
        if(props.type === 'user'){
            return (
                <div className="nav-item profile">
                    <div className="icon">
                        <PodDash />
                    </div>
                    <div className="name" style={{marginLeft: '1.55rem'}}>
                        Dashboard
                    </div>
                    <div className="arrow">
                        <MenuArrowSmall />
                    </div>
                    <div className="bridge"></div>
                    {makePodcastDrop()}
                </div>
            )
        } else {
            let name = props.userdata.Mobile;
            if(props.userdata.FName !== "" && props.userdata.LName !== ""){
                name = props.userdata.FName + " " + props.userdata.LName;
            }
            return (
                <div className="nav-item profile">
                    <div className="icon">
                        <UserProfile />
                    </div>
                    <div className="name">
                        {name}
                    </div>
                    <div className="arrow">
                        <MenuArrowSmall />
                    </div>
                    <div className="bridge"></div>
                    {makeProfile()}
                </div>
            )
        }
        
    }

    return (
    <StyleCss>
        <div className={"navbar " + ((opened) ? 'open' : '')}>
            <div className=" nav-item ham-btn" onClick={() => setOpen(!opened)}>
                <img src={HamMenu} alt={'menu'}/>
            </div>
            <Link to="/" className="image">
                <img src={logo} alt={"podkadeh logo"} />
            </Link>
            <div className="expand"></div>
            {navLastItem()}
        </div>
        <div className={"menu " + ((opened) ? 'open' : '')}>
            <div className="main-icon" onClick={() => setOpen(!opened)}>
               { (window.innerWidth > 800) ? <MenuArrow/> :<MenuClose />}
            </div>
            <div className="image">
                {(props.image.length) ? (
                    <img src={props.image} alt="podcast"/>
                ) : (
                    <UserProfile/>
                )}
            </div>
            <div className={"selector " + ((opened) ? 'open' : '')}>
                {makeSelector()}
            </div>
            <div className="devider"/>
            <div className="menu-container">
                {makeMenus()}
            </div>
        </div>
        <div className={"contents " + ((opened) ? 'open' : '')}>
            {props.children}
        </div>
    </StyleCss>
  );
}

export default MainLayoutV3;